/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "efmmesrjbwzyjooxvvop"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVmbW1lc3JqYnd6eWpvb3h2dm9wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MTA0ODgsImV4cCI6MjA4ODQ4NjQ4OH0.d1BJbqwiM6LCj96xaM1HMSw2LMjRnTH-Fak028Kb1F4"